import { styled } from "@mui/material/styles";

const HoverOverlay = styled("div")(({ theme }) => ({
  position: "relative",
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 168,
    backgroundColor: "rgba(37, 45, 95, 0.7)",
    transition: "opacity 0.1s ease-in",
    opacity: 0,
    [theme.breakpoints.up("mobile")]: {
      height: 321,
    },
  },
  "&:hover::after": {
    opacity: 1,
  },
}));

export default HoverOverlay;
